import { render } from "./Reset.vue?vue&type=template&id=adc799ce"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import exportComponent from "/home/alberto/repos/veltium/lan/web-firebase/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__